/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Native interpolator for simple {{param}} / {{nested.path}} templates.
 */
export function interpolateTemplate(template: string): (params?: any) => string {
  const source = template === null || template === undefined ? '' : String(template);
  return (params: any = {}) => {
    if (!source) {
      return source;
    }
    return source.replace(/\{\{\s*([\w.]+)\s*\}\}/gi, (_match, path: string) => {
      if (!params) {
        return '';
      }
      const parts = String(path).split('.');
      let value: any = params;
      for (let i = 0; i < parts.length; i++) {
        if (value === null || value === undefined) {
          return '';
        }
        value = value[parts[i]];
      }
      return value === null || value === undefined ? '' : String(value);
    });
  };
}
